import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Button from "../Component/Button";
import Footer from "../Component/Footer";
// import GreyLine from "../Component/GreyLine";
import Heading from "../Component/Heading";
import NavText from "../Component/NavText";
import { Controls, Player } from "@lottiefiles/react-lottie-player";
import { apiUrl } from "../Utils/constants";

function loadScript(src) {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = src;
    script.onload = () => {
      resolve(true);
    };
    script.onerror = () => {
      resolve(false);
    };
    document.body.appendChild(script);
  });
}
const PaymentContent = () => {
  const navigate = useNavigate();
  const storesel = useSelector((state) => state);
  const planNameredux = storesel.UrlData.planName;
  const emailParam = storesel.emailData?.emailStored;

  const myObject = storesel.UrlData.userDetails;
  let keys = Object.keys(myObject);
  if (myObject.Discount > 0) {
    keys = [
      "Plan Name",
      "Total Sessions",
      "Expiry Date",
      "Amount",
      "Discount",
      "Taxes",
      "Total Amount",
    ];
  } else {
    keys = [
      "Plan Name",
      "Total Sessions",
      "Expiry Date",
      "Amount",
      "Taxes",
      "Total Amount",
    ];
  }
  // const myObject = {
  //   "Plan Name": "Sweat Pilates",
  //   "Total Sessions": "14",
  //   "Expiry Date": "08-02-2023",
  //   "Total Amout": "₹8499",
  // };
  // -----loading spinne state----
  const [loading, setLoading] = useState(false);
  const [apiStatus, setApiStatus] = useState("");
  const [buttonClicked, setButtonClicked] = useState(false);
  const [emailParamsExists, setEmailFromParams] = useState(false);

  useEffect(() => {
    if (emailParam) {
      setEmailFromParams(true);
    }
  }, [emailParam]);

  const PaymentFunc = async () => {
    setButtonClicked(true);
    setLoading(true);

    if (myObject["Total Amount"] > 0) {
      // axios({
      //   method: "patch",
      //   url:
      //     apiUrl+"/updateTransaction/" +
      //     myObject.transactionid,
      // })
      axios({
        method: "patch",
        url:
          apiUrl+"/updateTransaction/" +
          myObject.transactionid,
        data: { statusmsg: "user opened the razorpay popup" },
      })
        .then((response) => {
          setApiStatus("success");
        })
        .catch((error) => {
          setApiStatus("error");
        });

        if(!emailParamsExists){
          const res = await loadScript(
            "https://checkout.razorpay.com/v1/checkout.js"
          );

          if (!res) {
            alert("Razorpay SDK failed to load. Are you online?");
            return;
          }
          const options = {
            key: "rzp_live_CPP9cTVJFe1gbY",
            currency: "INR",
            amount: myObject["Total Amount"],
            order_id: myObject.orderid,
            name: myObject["Plan Name"],
            description: "",
            image: "https://sweatpilates.in/archive/a.jpg",
            theme: {
              color: "#9900FF",
            },
            handler: function (response) {
              // alert(response.razorpay_payment_id);
              // alert(response.razorpay_order_id);
              // alert(response.razorpay_signature);
              if (response) {
                navigate(`/${planNameredux}/thank`);
              }
            },
            modal: {
              ondismiss: function () {
                // alert("hjhii");
                setButtonClicked(false);
                // var sendurl = axios({
                //   method: "patch",
                //   url:
                //     apiUrl+`/updateTransaction/` +
                //     myObject.transactionid +
                //     ``,
                // })
                var sendurl = axios({
                  method: "patch",
                  url:
                    apiUrl+`/updateTransaction/` +
                    myObject.transactionid +
                    ``,
                  data: { statusmsg: "User closed the razorpay popup" },
                })
                  .then((response) => {
                    console.log("");
                  })
                  .catch((error) => {
                    console.log("");
                  });
              },
              // Boolean indicating whether pressing escape key
              // should close the checkout form. (default: true)
              escape: true,
              // Boolean indicating whether clicking translucent blank
              // space outside checkout form should close the form. (default: false)
              backdropclose: false,
            },
            prefill: {
              name: myObject.firstname,
              email: myObject.email,
              phone_number: myObject.phone,
            },
            notes: {
              transaction: myObject.transactionuid,
              startdate: myObject.startdate,
              plan: myObject.planid,
              customer: myObject.userid,
              session: myObject.sessionid,
              name: myObject["Plan Name"],
              branch: myObject.branchid,
              days: myObject.daystime,
              total: myObject["Total Sessions"],
              istrial: 0,
              email: myObject.email,
              firstname: myObject.firstname,
            },
          };
          const paymentObject = new window.Razorpay(options);
          paymentObject.open();
        }else{
          const options = {
            key: "rzp_live_CPP9cTVJFe1gbY",
            currency: "INR",
            amount: myObject["Total Amount"],
            order_id: myObject.orderid,
            name: myObject["Plan Name"],
            description: "",
            image: "https://sweatpilates.in/archive/a.jpg",
            theme: {
              color: "#9900FF",
            },
            prefill: {
              name: myObject.firstname,
              email: myObject.email,
              contact: myObject.phone,
            },
            notes: {
              transaction: myObject.transactionuid,
              startdate: myObject.startdate,
              plan: myObject.planid,
              customer: myObject.userid,
              session: myObject.sessionid,
              name: myObject["Plan Name"],
              branch: myObject.branchid,
              days: myObject.daystime,
              total: myObject["Total Sessions"],
              istrial: 0,
              email: myObject.email,
              firstname: myObject.firstname,
            },
          };
          window.location.href = `/${planNameredux}/payment?json=${JSON.stringify(options)}`;
        }
    } else {
      var bodyData = {
        firstname: myObject.firstname,
        email: myObject.email,
        customer: myObject.userid,
        plan: myObject.planid,
        session: myObject.sessionid,
        name: myObject["Plan Name"],
        days: myObject.daystime,
        base_amount: myObject["Total Amount"],
        transaction: myObject.transactionuid,
        startdate: myObject.startdate,
        branch: myObject.branchid,
        total: myObject["Total Sessions"],
        istrial: myObject.isTrial,
      };

      axios({
        method: "post",
        url: apiUrl+"/buyTrialPlan",
        data: bodyData,
        headers: { "Content-Type": "application/json" },
      })
        .then((response) => {
          setApiStatus("success");
          if(!emailParamsExists){
            navigate(`/${planNameredux}/thank`);          
          }else{
            window.location.href = `/${planNameredux}/thank`
          }
        })
        .catch((error) => {
          setApiStatus("error");
        });
    }
    setLoading(false);
  };

  return (
    // value: /^[a-zA-Z0-9']*$/g,
    <>
      <div className="home-content-container payment-content-container">
        <NavText name={myObject.name} planname={myObject["Plan Name"]} />
        <Heading headingText="PAYMENT BREAKDOWN" />
        {/* <GreyLine /> */}

        <div className="payment-list-div">
          {keys.map((value, index) => (
            <div className="payment-list-item">
              <div className="payment-list-item-row">
                <>
                  <p>{value}:</p>
                  <p className="payment-list-item-row-value">
                    {["Amount", "Taxes", "Total Amount"].includes(value)
                      ? "₹"
                      : ""}
                    {["Discount"].includes(value) ? "- ₹" : ""}
                    {myObject[value]}
                    {/* {myObject.max_sessions} */}
                  </p>
                </>
              </div>
              {/* <GreyLine /> */}
            </div>
          ))}

          {!buttonClicked ? (
            <Button btnText="Pay Now" onClick={PaymentFunc} />
          ) : loading || apiStatus !== "success" ? (
            <Player
              autoplay
              loop
              src="asset/Img/spinner.json"
              style={{ width: "50px", height: "50px" }}
            >
              <Controls
                visible={false}
                buttons={["play", "repeat", "frame", "debug"]}
              />
            </Player>
          ) : (
            <Button btnText="Pay Now" onClick={PaymentFunc} />
          )}
        </div>

        <Footer />
      </div>
    </>
  );
};

export default PaymentContent;